import React from 'react';
import PropTypes from 'prop-types';
import './ShortcutsPanel.css';
import IconClose from '../svg/IconClose'

// All shorcuts available in the app
function ShortcutsPanel({ onClose, cancelClick, modalHasEntered }) {
  const onCancel = () => {
    onClose();
    cancelClick();
  }

  return (
    <div className={`flexColumn shorcuts_panel`}>
      <div className={`flexColumn sp-container`}>
        <div className={`flexRow sp-header`}>
          <span className={`sp-title-header`}>Keyboard Shorcuts</span>
          <IconClose size={20} onClick={onCancel} color={`#BDBDBD`} className={`sp-close-header`} />
        </div>
        <div className={`sp-body`}>

          <div className={`flexRow sp-block`}>
              <div className={`sp-list`}>
                <div className={`flexRow sp-line`}>
                  <div className={`sp-label`}></div>
                  <div className={`sp-shortcut`}></div>
                </div>
              </div>
              <div className={`sp-list`}>
                <div className={`flexRow sp-line`}>
                  <div className={`sp-label`}></div>
                  <div className={`sp-shortcut`} style={{textAlign: `right`}}>
                    <span className={`sp-toggle`}>Toggle Shortcuts</span>
                    <span>?</span>
                  </div>
                </div>
              </div>
          </div>

          <div className={`flexRow sp-block`}>
            <div className={`type-title sp-mid-title`}>Left Deck</div>
            <div className={`type-title sp-mid-title`}>Right Deck</div>
          </div>

          <div className={`flexRow sp-block space`}>
            <div className={`sp-list`}>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Load Selected Track</div>
                <div className={`sp-shortcut`}>Shift + Left Arrow</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Cue</div>
                <div className={`sp-shortcut`}>Q</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Play/Pause</div>
                <div className={`sp-shortcut`}>W</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Set/Launch Cue Point</div>
                <div className={`sp-shortcut`}>Shift + 1, 2, 3, 4, 5</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Erase Cue Point</div>
                <div className={`sp-shortcut`}>Shift + Command + 1, 2, 3, 4, 5</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Loop On/Off</div>
                <div className={`sp-shortcut`}>K</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Tempo Adjust Down</div>
                <div className={`sp-shortcut`}>T</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Tempo Adjust Up</div>
                <div className={`sp-shortcut`}>Y</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Beat Jump -</div>
                <div className={`sp-shortcut`}>D</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Beat Jump +</div>
                <div className={`sp-shortcut`}>F</div>
              </div>
              {/* <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Crossfader</div>
                <div className={`sp-shortcut`}>Shift + Command + Left Arrow</div>
              </div> */}
            </div>
            <div className={`sp-list`}>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Load Selected Track</div>
                <div className={`sp-shortcut`}>Shift + Right Arrow</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Cue</div>
                <div className={`sp-shortcut`}>A</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Play/Pause</div>
                <div className={`sp-shortcut`}>S</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Set/Launch Cue Point</div>
                <div className={`sp-shortcut`}>Shift + 6, 7, 8, 9, 0</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Erase Cue Point</div>
                <div className={`sp-shortcut`}>Shift + Command + 6, 7, 8, 9, 0</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Loop On/Off</div>
                <div className={`sp-shortcut`}>L</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Tempo Adjust Down</div>
                <div className={`sp-shortcut`}>G</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Tempo Adjust Up</div>
                <div className={`sp-shortcut`}>H</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Beat Jump -</div>
                <div className={`sp-shortcut`}>C</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Beat Jump +</div>
                <div className={`sp-shortcut`}>V</div>
              </div>
              {/* <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Crossfader</div>
                <div className={`sp-shortcut`}>Shift + Command + Right Arrow</div>
              </div> */}
            </div>
          </div>

          <div className={`flexRow sp-block`}>
            <div className={`type-title sp-mid-title`}>Player</div>
            {/* <div className={`type-title sp-mid-title`}>Automix</div> */}
          </div>

          <div className={`flexRow sp-block space`}>
            <div className={`sp-list`}>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Zoom Waveform In/Out</div>
                <div className={`sp-shortcut`}>Shift + (+) or (-)</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Play/Pause Both Decks</div>
                <div className={`sp-shortcut`}>Shift + Space Bar</div>
              </div>
            </div>
            {/* <div className={`sp-list`}>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Skip Song Forward</div>
                <div className={`sp-shortcut`}>Control + Right Arrow</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Skip Song Backward</div>
                <div className={`sp-shortcut`}>Control + Left Arrow</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Shuffle</div>
                <div className={`sp-shortcut`}>Control + X</div>
              </div>
            </div> */}
          </div>

          <div className={`flexRow sp-block`}>
            <div className={`type-title sp-mid-title full`}>Discover</div>
          </div>

          <div className={`flexRow sp-block`}>
            <div className={`sp-list`}>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Move Up/Down (Tracks)</div>
                <div className={`sp-shortcut`}>Up/Down Arrow</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Move Up/Down (Playlists)</div>
                <div className={`sp-shortcut`}>Control + Shift + Up/Down Arrow</div>
              </div>
              {/* <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Shift Highlight Focus</div>
                <div className={`sp-shortcut`}>Tab</div>
              </div> */}
              {/* <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Show/Hide Playlist Directory</div>
                <div className={`sp-shortcut`}>Shift + O or Shift + I</div>
              </div> */}
            </div>
            <div className={`sp-list`}>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Delete Track</div>
                <div className={`sp-shortcut`}>Delete</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Delete Playlist</div>
                <div className={`sp-shortcut`}>Control + Shift + Delete</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Select All</div>
                <div className={`sp-shortcut`}>Control + A</div>
              </div>
              <div className={`flexRow sp-line`}>
                <div className={`sp-label`}>Unselect All</div>
                <div className={`sp-shortcut`}>Esc</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

ShortcutsPanel.propTypes = {
  onClose: PropTypes.func.isRequired,
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default ShortcutsPanel;
